/**
 * EMPRICS Logo Interactive V9.1
 * Click-to-lock letter selection, breathing pulse, helium float, division dropdown
 * Division click navigates to division page
 * Deployed: 2026-04-12
 */
(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function slugify(text) {
    return text.toLowerCase()
      .replace(/\s+division$/i, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function initLogoInteraction(container) {
    var chars = container.querySelectorAll('.lc[data-d]');
    var dpEl = container.querySelector('.emprics-dp');
    var ddEl = container.querySelector('.emprics-dd');
    var dlEl = container.querySelector('.emprics-dd__list');
    var nameEl = container.querySelector('.emprics-dp__name');
    var subEl = container.querySelector('.emprics-dp__subdiv');
    var titleEl = ddEl ? ddEl.querySelector('.emprics-dd__title') : null;

    if (!chars.length || !dpEl || !ddEl || !dlEl || !nameEl || !subEl) return;

    var lockedChar = null;
    var selectedDivs = {};

    function resetPanel() {
      nameEl.textContent = 'Select Discipline';
      nameEl.style.color = '#bbb';
      subEl.textContent = 'Click a letter';
      subEl.classList.add('muted');
      dpEl.classList.remove('active');
      ddEl.classList.remove('open');
    }

    function setPanel(d, c, divText) {
      nameEl.textContent = d;
      nameEl.style.color = c;
      subEl.textContent = divText;
      subEl.classList.remove('muted');
      dpEl.classList.add('active');
      dpEl.style.setProperty('--ac', c);
      ddEl.style.setProperty('--ac', c);
    }

    function buildList(divsStr, c, discipline) {
      dlEl.innerHTML = '';
      var currentSel = selectedDivs[discipline] || null;
      divsStr.split(',').forEach(function(raw) {
        var d = raw.trim();
        var li = document.createElement('li');
        li.className = 'emprics-dd__item' + (d === currentSel ? ' selected' : '');
        li.textContent = d;
        li.style.setProperty('--ac', c);
        li.addEventListener('click', function(e) {
          e.stopPropagation();
          selectedDivs[discipline] = d;
          subEl.textContent = d;
          subEl.classList.remove('muted');
          var items = dlEl.querySelectorAll('.emprics-dd__item');
          for (var i = 0; i < items.length; i++) items[i].classList.remove('selected');
          li.classList.add('selected');

          // Navigate to the division page
          var slug = slugify(d);
          var url = '/pages/' + slug;
          setTimeout(function() {
            ddEl.classList.remove('open');
            window.location.href = url;
          }, 200);
        });
        dlEl.appendChild(li);
      });
    }

    function lockChar(ch) {
      var d = ch.dataset.d;
      var c = ch.dataset.c;
      var divs = ch.dataset.divs;

      if (lockedChar === ch) {
        ch.classList.remove('locked');
        lockedChar = null;
        for (var i = 0; i < chars.length; i++) chars[i].classList.add('can-hover');
        resetPanel();
        return;
      }

      if (lockedChar) lockedChar.classList.remove('locked');

      lockedChar = ch;
      for (var i = 0; i < chars.length; i++) {
        chars[i].classList.remove('can-hover');
        chars[i].classList.remove('locked');
      }
      ch.classList.add('locked');

      var divText = selectedDivs[d] || 'Select a division';
      setPanel(d, c, divText);
      if (titleEl) titleEl.textContent = d + ' Divisions';
      buildList(divs, c, d);
      ddEl.classList.add('open');
    }

    for (var i = 0; i < chars.length; i++) {
      (function(ch) {
        ch.addEventListener('click', function(e) {
          e.stopPropagation();
          lockChar(ch);
        });
      })(chars[i]);
    }

    document.addEventListener('click', function(e) {
      if (!container.contains(e.target) && lockedChar) {
        lockedChar.classList.remove('locked');
        lockedChar = null;
        for (var i = 0; i < chars.length; i++) chars[i].classList.add('can-hover');
        resetPanel();
      }
    });

    ddEl.addEventListener('click', function(e) { e.stopPropagation(); });
  }

  function init() {
    var containers = document.querySelectorAll('[data-emprics-logo]');
    for (var i = 0; i < containers.length; i++) {
      initLogoInteraction(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var containers = e.target.querySelectorAll('[data-emprics-logo]');
    for (var i = 0; i < containers.length; i++) {
      initLogoInteraction(containers[i]);
    }
  });
})();